/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { invoicePaymentEmail } from '../../axios/invoicePaymentEmail'
import type {
	InvoicePaymentEmailError,
	InvoicePaymentEmailPathParams,
	InvoicePaymentEmailResponse,
} from '../../types/InvoicePaymentEmail'

export const invoicePaymentEmailMutationKey = () =>
	[{ url: '/:organisation/invoices/:invoice/payments/:payment/send-email' }] as const

export type InvoicePaymentEmailMutationKey = ReturnType<typeof invoicePaymentEmailMutationKey>

export type InvoicePaymentEmailVariables = {
	organisation: InvoicePaymentEmailPathParams['organisation']
	invoice: InvoicePaymentEmailPathParams['invoice']
	payment: InvoicePaymentEmailPathParams['payment']
}

/** @see backend/nexus/modules/Billing/Http/Controllers/InvoicePaymentController.php InvoicePaymentController::email */
export function useInvoicePaymentEmail<TContext = unknown>(
	options?: UseMutationOptions<
		InvoicePaymentEmailResponse,
		AxiosError<InvoicePaymentEmailError>,
		InvoicePaymentEmailVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: invoicePaymentEmailMutationKey(),
		mutationFn: ({ organisation, invoice, payment }: InvoicePaymentEmailVariables) =>
			invoicePaymentEmail(organisation, invoice, payment, config).then(res => res.data),
		...options,
	})
}
